export const hashCode = (str) => {
  // eslint-disable-next-line
  return str.split('').reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);
};

export const sanitize = (string) => {
  return string?.replace(/</g, '\\u003c');
};
